module.exports = __webpack_public_path__ + "img/regulatory-four.2d496c2f.png";